export const LESSON_TYPE = {
    STORNO: 'storno',
    INDIVIDUAL: 'individual',
    WEX: 'wex',
    STAFF: 'staff',
};
export const LESSON_TYPES = [
    {
        id: LESSON_TYPE.STORNO,
        title: 'Storno',
    },
    {
        id: LESSON_TYPE.INDIVIDUAL,
        title: 'Individuální výuka',
    },
    {
        id: LESSON_TYPE.WEX,
        title: 'WEX',
    },
    {
        id: LESSON_TYPE.STAFF,
        title: 'Služba',
    },
];
